<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8984 2.90039C15.5929 2.90039 19.3984 6.70597 19.3984 11.4004C19.3984 13.4589 18.6658 15.3457 17.4482 16.8164L20.7666 20.1348C21.0785 20.4471 21.0786 20.9533 20.7666 21.2656C20.4542 21.578 19.9472 21.578 19.6348 21.2656L16.3174 17.9482C14.8462 19.1671 12.9582 19.9004 10.8984 19.9004C6.20402 19.9004 2.39844 16.0948 2.39844 11.4004C2.39844 6.70597 6.20402 2.90039 10.8984 2.90039ZM10.8984 4.5C7.08767 4.5 3.99805 7.58963 3.99805 11.4004C3.99805 15.2112 7.08767 18.3008 10.8984 18.3008C12.7149 18.3008 14.3655 17.5966 15.5977 16.4492C15.6349 16.3757 15.6847 16.3065 15.7461 16.2451C15.8078 16.1834 15.8773 16.134 15.9512 16.0967C17.0966 14.8649 17.7988 13.2151 17.7988 11.4004C17.7988 7.58963 14.7092 4.5 10.8984 4.5Z"
      fill="currentColor"
    />
  </svg>
</template>
